import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f0d1a1de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "network-config-wrap" }
const _hoisted_2 = { class: "network-config-wrap cm-form-info-grid" }
const _hoisted_3 = { class: "cm-form-item" }
const _hoisted_4 = { class: "cm-form-item" }
const _hoisted_5 = { class: "cm-form-item" }
const _hoisted_6 = { class: "cm-form-item" }
const _hoisted_7 = {
  key: 0,
  class: "cm-form-item"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "自动获取DNS地址", -1))
const _hoisted_9 = { class: "cm-form-item" }
const _hoisted_10 = { class: "cm-form-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FoldPanel = _resolveComponent("FoldPanel")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compData, (item, index) => {
      return (_openBlock(), _createBlock(_component_FoldPanel, {
        class: "fold-panel",
        key: index,
        title: item.name,
        icon: _ctx.getSvgIconDataUrl('views/dashboard/group/client/terminal-info/network-config/_images/network')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.netAutoIp')), 1),
              _createElementVNode("span", null, _toDisplayString(item.is_auto_ip ? _ctx.$t('searchFilterBar.yes') : _ctx.$t('searchFilterBar.no')), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.netCurrentIp')), 1),
              _createElementVNode("span", null, _toDisplayString(item.current_ip || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.netSubnetMask')), 1),
              _createElementVNode("span", null, _toDisplayString(item.current_subnet_mask || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.netDefaultGateway')), 1),
              _createElementVNode("span", null, _toDisplayString(item.default_gateway || '--'), 1)
            ]),
            (0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString(item.is_auto_dns ? _ctx.$t('searchFilterBar.yes') : _ctx.$t('searchFilterBar.no')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.netDnsServers')), 1),
              _createElementVNode("span", null, _toDisplayString(item.dns || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.macAddress')), 1),
              _createElementVNode("span", null, _toDisplayString(item.mac || '--'), 1)
            ])
          ])
        ]),
        _: 2
      }, 1032, ["title", "icon"]))
    }), 128)),
    (!_ctx.compData.length)
      ? (_openBlock(), _createBlock(_component_EmptyData, {
          key: 0,
          height: "100%"
        }))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}